const UpDown = [
    {id: "0", value: "突破"},    
    {id: "1", value: "跌破"}
  ];  
  
  export default UpDown  